export type LineState = 'open' | 'connecting' | 'close' | 'logged_out';

export interface WhatsAppLine {
  instance: string;
  label?: string;
  enabled: boolean;
  registered: boolean;
  exists: boolean;
  state?: LineState;
  /** Digits only, no plus sign. */
  phone?: string;
  profile_name?: string;
  profile_pic_url?: string;
  /** Epoch seconds. */
  state_at?: number;
  disconnected_at?: string;
  disconnect_reason?: number;
  created_by?: string;
  created_at?: number;
}

export interface EvolutionServer {
  reachable: boolean;
  licensed: boolean;
  version?: string;
  error?: unknown;
}

export interface WhatsAppLinesPayload {
  enabled: boolean;
  /** Licence notice from the backend; must be shown to admins. */
  notice: string;
  server: EvolutionServer | null;
  lines: WhatsAppLine[];
  reachable: boolean;
  error: unknown;
}

export interface LineSettings {
  rejectCall: boolean;
  msgCall: string;
  groupsIgnore: boolean;
  alwaysOnline: boolean;
  readMessages: boolean;
  readStatus: boolean;
  syncFullHistory: boolean;
}

export interface LineConnect {
  state: 'open' | 'connecting';
  /** data:image/png;base64 URL */
  qr: string | null;
  pairing_code: string | null;
  count?: number;
}

export const INSTANCE_ID_PATTERN = /^[a-z0-9][a-z0-9-]{1,31}$/;
